import { Tooltip, Typography } from "@mui/material";
import Humanize from "humanize-plus";

import { toDefaultInt } from "../../lib/Util";

type HumanRowsProps = {
  rowCount?: number | null;
  testLabel?: string;
  showTooltip?: boolean;
  showArrow?: boolean;
};

const HumanRows = ({ rowCount, testLabel, showTooltip = true, showArrow = false }: HumanRowsProps) => {
  if (!rowCount) {
    return null;
  }

  const humanRows = (
    <span data-testid={testLabel}>
      <Typography variant="body.small.regular">{toDefaultInt(rowCount)} Rows</Typography>
    </span>
  );
  if (!showTooltip) {
    return humanRows;
  }

  return (
    <Tooltip placement="left" title={`${Humanize.intComma(rowCount)} rows`} arrow={showArrow} id="tooltip">
      <Typography variant="body.small.regular">{humanRows}</Typography>
    </Tooltip>
  );
};

type HandleType = {
  url?: string;
  filename?: string;
  handle?: string;
  md5?: string;
  path?: string;
  report_date?: string;
  start_date?: string;
  end_date?: string;
  report_time?: string;
  start_time?: string;
  end_time?: string;
};

const NameFromHandle = ({ children }: { children: HandleType }) => {
  const name = getNameFromHandle(children);
  return <span data-testid="name">{name || "Unknown"}</span>;
};

const getNameFromHandle = (handle: HandleType) => {
  let name = "";
  if (!handle) {
    return name;
  }

  if (handle.url) {
    name = `${handle.url}`;
  } else if (handle.filename) {
    name = `${handle.filename}`;
  } else if (handle.handle) {
    name = `${handle.handle}`;
  } else if (handle.report_date) {
    name = handle.report_date;
  } else if (handle.start_date && handle.end_date) {
    name = `${handle.start_date} - ${handle.end_date}`;
  } else if (handle.report_time) {
    name = `${handle.report_time}`;
  } else if (handle.start_time && handle.end_time) {
    name = `${handle.start_time} - ${handle.end_time}`;
  }

  return name;
};

const toPercentValue = ({ n, d }: { n?: number | string | null; d?: number | string | null }) => {
  if (!d || n === undefined || n === null || n === "") {
    return null;
  }

  const numerator = parseFloat(n.toString());
  const denominator = parseFloat(d.toString());
  if (isNaN(denominator) || isNaN(numerator)) {
    return null;
  }

  if (isFinite(denominator)) {
    return Math.floor((numerator / denominator) * 100);
  }
  return null;
};

export { getNameFromHandle, HumanRows, NameFromHandle, toPercentValue };
export type { HandleType };
